module.exports = __webpack_public_path__ + "static/media/sickFood.a5276127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Restaurant/sickFood.jpg
// module id = 347
// module chunks = 0